'use client';

import { useRouter } from "next/navigation";

import useLoginModal from "@/app/hooks/useLoginModal";

import Button from "./Button";
import Heading from "./Heading";

interface EmptyStateProps {
  title?: string;
  subtitle?: string;
  showReset?: boolean;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  title = "No exact matches",
  subtitle = "Try changing or removing some of your filters.",
  showReset
}) => {
  const router = useRouter();
  const loginModal = useLoginModal();
  const showLogin = /please log ?in/i.test(`${title} ${subtitle}`);

  const handleResetFilters = async () => {
    router.replace('/');
    
  };

  return ( 
    <div 
      className="
        h-[60vh]
        flex 
        flex-col 
        gap-2 
        justify-center 
        items-center 
      "
    >
      <Heading
        center
        title={title}
        subtitle={subtitle}
      />
      <div className="w-48 mt-4">
        {showReset && (
          <Button
            outline
            label="Remove all filters"
            // onClick={() => router.push('/')}
            onClick={handleResetFilters}
          />
        )}
        {showLogin && (
          <Button
            label="Login"
            onClick={loginModal.onOpen}
          />
        )}
      </div>
    </div>
   );
}
 
export default EmptyState;